import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { RootState } from "features/config/store";
import {
  LogoutHubLinkResponse,
  LogoutHubLinkRepository,
} from "features/hublink/data/tei-hub-link.repository";

export enum LogoutHubLinkState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: LogoutHubLinkState;
  message: string | undefined;
}

const initialState: InitialState = {
  status: LogoutHubLinkState.initial,
  message: undefined,
};

export const logoutHubLink = createAsyncThunk(
  "logoutHubLink",
  async (_, { rejectWithValue }) => {
    try {
      const response: LogoutHubLinkResponse = await LogoutHubLinkRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const logoutHubLinkSlice = createSlice({
  name: "logoutHubLink",
  initialState,
  reducers: {
    resetLogoutHubLink: (state) => {
      state.status = LogoutHubLinkState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutHubLink.pending, (state) => {
        state.status = LogoutHubLinkState.inProgress;
      })
      .addCase(logoutHubLink.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;

          state.status = LogoutHubLinkState.success;
          state.message = message;
        }
      })
      .addCase(logoutHubLink.rejected, (state, action) => {
        state.status = LogoutHubLinkState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectLogoutHubLink = (state: RootState) => state.logoutHubLink;

export const { resetLogoutHubLink } = logoutHubLinkSlice.actions;

export default logoutHubLinkSlice.reducer;
